
<template>
    <div class="login-page" id="login">
        <div class="login-content">
            <div class="login-logo text-center">
                <img :src="imagePath" alt="Dealer Pro Application" width="70%">
            </div>
            <div class="login-container">
                <h2 class="mb-3">Sign In</h2>
                <div class="form-row">
                    <div class="col form-group">
                        <input name="username" v-model="loginUsername" id="username" tabindex="1" class="form-control" placeholder="Username *" value="" type="text">
                        <div class="field-error">{{ logerror_msg }}</div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col form-group">
                        <input name="password" v-model="loginPassword" id="password" tabindex="2" class="form-control" placeholder="Password *" type="password">
                        <div class="field-error">{{ error }} {{ passerror_msg }}</div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col form-group">
                        <div class="custom-checkbox">
                            <label for="is_miscellaneous" class="checkbox-custom">
                                Remember Me
                                <input type="checkbox" id="is_miscellaneous" name="is_miscellaneous">
                                <span class="checkmark"></span>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="form-row mt-3">
                    <button id="loginbtn" type="submit" class="btn btn-primary mr-4" v-on:click="login(this)">{{loginBtnText}}</button>
                    <router-link class="forgot-password" v-bind:to="{name: 'ForgotPassword'}">Forgot password?</router-link>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    import EventBus from './event-bus.js';

    export default {
        name: "Login",
        data: () => ({
            imagePath: process.env.LOGO_PATH,
            loginBtnText:"Login",
            logerror_msg : "",
            passerror_msg : "",
            loginUsername: "",
            loginPassword: "",
            error:""
        }),
        created: function() {

        },
        mounted: function() {

            // PR - If token is already available...
            if ( localStorage.getItem("tkn") != "" && localStorage.getItem("tkn") != null) {
                window.location.href = "/dashboard";
            }

            //hide header
            EventBus.$emit('logged-in', false,"","","");

            $(document).ready(function(){
                $("#login").height($(window).height() + 'px');
            });
            $(window).resize(function(){
                $("#login").height($(window).height() + 'px');
            });
            var self = this;
            $("input").keypress(function(e) {
                if (e.keyCode === 13) {
                    if (e.target.id == 'username' || e.target.id == 'password') {
                        self.login();
                    }
                }
            });
        },
        methods: {

            login: function () {

                var self = this;

                //console.log("home route: "+process.env.API)
                self.logerror_msg = "";
                self.passerror_msg = "";
                self.error = "";

                if (this.loginUsername == "") {
                    self.logerror_msg = "Username can not be left empty";
                }  if (this.loginPassword == "") {
                    self.passerror_msg = "Password can not be left empty";
                }

                if ( self.logerror_msg == "" && self.passerror_msg =="") {

                    self.loginBtnText = "Login...";
                    $("#loginbtn").attr("disable",true);

                    $.ajax({
                        url: process.env.ROOT_API + "/login",
                        type: "POST",
                        crossDomain: true,
                        data: {
                            username: self.loginUsername,
                            password: self.loginPassword
                        },
                        success: function (data) {

                            // self.loginBtnText = "Login";
                            $("#loginbtn").text("Login");
                            $("#loginbtn").attr("disable",false);

                            if (data.status == "success") {
                                localStorage.setItem("tkn", data.content.tkn);
                                localStorage.setItem("user_obj", JSON.stringify(data.content.user_obj));

                                EventBus.$emit('logged-in', true, data.content.user_obj["first_name"], data.content.roles, data.content.user_obj["username"], data.content.user_obj["file_path"]);

                                /* commented because of no use
                                if (data.content.user_obj.roles[0].name.toLowerCase() === 'customer'){
                                  window.location.href = "/asset/list"; // redirecting to the asset list page if the logged in user is customer
                                }else{
                                  if(self.$route.params.redirect_url != null && self.$route.params.redirect_url != undefined && self.$route.params.redirect_url != ''){
                                    window.location.href = self.$route.params.redirect_url;
                                  } else {

                                    if (data.content.user_obj.roles.includes('technician')){//data.content.user_obj.roles[0].name.toLowerCase() == 'technician' ) {
                                      window.location.href = "/workorder/list";
                                    } else if ( data.content.user_obj.roles.includes('fueler')){//data.content.user_obj.roles[0].name.toLowerCase() == 'fueler' ) {
                                      window.location.href = "/fuel-ticket/list";
                                    } else {

                                      if ( data.content.user_obj.roles[0].landingpage ) {
                                        localStorage.setItem("landingpage",data.content.user_obj.roles[0].landingpage.toLowerCase());
                                        if ( data.content.user_obj.roles[0].landingpage.toLowerCase() == 'service'){//data.content.user_obj.roles[0].name.toLowerCase() == 'fueler' ) {
                                          window.location.href = "/service-dashboard";
                                        } else if ( data.content.user_obj.roles[0].landingpage.toLowerCase() == 'lease'){//data.content.user_obj.roles[0].name.toLowerCase() == 'fueler' ) {
                                          window.location.href = "/lease-dashboard";
                                        } else if ( data.content.user_obj.roles[0].landingpage.toLowerCase() == 'rental'){//data.content.user_obj.roles[0].name.toLowerCase() == 'fueler' ) {
                                          window.location.href = "/rental-dashboard";
                                        } else if ( data.content.user_obj.roles[0].landingpage.toLowerCase() == 'account'){//data.content.user_obj.roles[0].name.toLowerCase() == 'fueler' ) {
                                          window.location.href = "/account-dashboard";
                                        } else {
                                          window.location.href = "/dashboard";
                                        }

                                      } else {
                                        localStorage.setItem("landingpage",'dashboard');
                                        window.location.href = "/dashboard";
                                      }


                                    }





                                  }
                                } */

                                localStorage.setItem("landingpage",'dashboard');
                                window.location.href = "/dashboard";

                                // checking if landingpage is stored in localStorage
                                $checkLandingPage = localStorage.getItem('landingpage');
                                if($checkLandingPage == null || $checkLandingPage == ''){
                                    localStorage.setItem("landingpage", 'dashboard');
                                }
                            }else{
                                self.error = data.message;
                            }

                            //self.$router.push("/user/list");
                        },
                        error: function (xhr, exception) {

                            // self.Loginbtn = "Login";
                            $("#loginbtn").text("Login");
                            $("#loginbtn").attr("disable",false);
                            if (xhr.status == 0) {
                                self.error = "Remote server cannot be reached";
                            } else {
                                self.error = jQuery.parseJSON(xhr.responseText).message;
                            }
                        }
                    });
                }
            }

        }
    };
</script>
<style scope>

.login-error{
    margin-top: 45px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue